<template>
  <section
    class="splash-page splash-page--desktop"
    :class="[{
      'is-backpack': isBackpack
    }]"
    v-show="!isLoading"
    @click="backgroundClick"
  >
    <div class="splash-page-modal-top-nav-close splash-page__nav-close" @click.stop="closeClick">
      <span class="icon-close"></span>
    </div>

    <div
      :class="[
        'splash-page__header-tools',
        regionIsApac ?  'splash-page__header-tools--apac' : ''
      ]"
      v-show="verifyModuleVisibility('header')"
    >
      <img
        class="splash-page__arrow splash-page__arrow--tools"
        :src="`${ customsAssets }/images/customizer/swipe-to-access-arrow-step3.png`"
      >
      <label class="splash-page__label">{{ getTranslation('headerTools') }}</label>
    </div>

    <div class="splash-page__logo" :class="[regionIsApac ?  'splash-page__logo--apac' : '']">
      <img :src="`${ customsAssets }/images/customizer/customs-logo.png`" />
    </div>

    <div v-show="verifyModuleVisibility('rotate')" :style="{ opacity }" class="splash-page__instruction splash-page__instruction--rotate">
      <label class="splash-page__label"> {{ this.getRotateTranslation() }} </label>
    </div>

    <div
      v-show="verifyModuleVisibility('rotate')"
      class="splash-page__component"
      :class="[{
        'splash-page__component--backpack': isBackpack,
        'splash-page__component--apparel': isApparel,
        'splash-page__component--apac': regionIsApac
      }]"
      :style="{ opacity }"
    >
      <slot></slot>

      <div
        class="splash-page__rotate splash-page__rotate--up"
        ref="rotateUp"
        :class="{'rotate-up--is-backpack': isBackpack, 'is-apac' : regionIsApac}"
      >
        <img :src="`${ customsAssets }/images/customizer/rotate-up.png`" />
      </div>
      <div
        class="splash-page__rotate splash-page__rotate--down"
        ref="rotateDown"
        :class="[{'rotate-down--is-backpack': isBackpack, 'is-apac' : regionIsApac }]"
      >
        <img :src="`${ customsAssets }/images/customizer/rotate-down.png`" />
      </div>
    </div>

    <div class="skip-cta splash-page__skip" :class="[regionIsApac ?  'splash-page__skip--apac' : '']">
      <button class="splash-page__label" @click="onSkip">
        {{ getTranslation('skipToGetStarted') }}
      </button>
    </div>

    <div
      :class="[ 'splash-page__faqs', 'checkout-faqs', regionIsApac ?  'splash-page__faqs--apac' : '']"
      v-show="verifyModuleVisibility('faqs')"
    >
      <button
        id="faqs"
        @click="faqsAction"
        class="splash-page__label"
      >
        {{ getTranslation('faqs') }}
      </button>
    </div>
    <div
      class="see-all-customize-parts splash-page__all-customize-parts"
      v-show="verifyModuleVisibility('all_parts')"
      ref="partsCustomize"
    >
      <label class="splash-page__label">{{ getTranslation('allParts') }}</label>
      <img
        :src="`${ customsAssets }/images/customizer/parts-customize-arrow-down.png`"
        class="splash-page-desktop__arrow"
      />
    </div>
    <div class="add-your-own-all splash-page__add-your-own"
      v-show="verifyModuleVisibility('tabs')"
    >
      <label class="splash-page__label">{{ getTranslation('addYourOwn') }}</label>
      <img
        class="splash-page-desktop__arrow"
        :src="`${ customsAssets }/images/customizer/add-your-own-arrow-step2.png`"
      />
    </div>
  </section>
</template>

<script>
export default {
  name: "simplifiedSplashPage",
  props: {
    isLoading: {
      type: Boolean,
      default: true
    },
    isTouchStarted: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      opacity: 1,
      styledElements: {},
      initialTimestamp: null,
      model3DContainerEl: null,
    }
  },
  computed: {
    translations() {
      return this.$store.state.translations.data;
    },
    isApparel() {
      return this.$store.getters['utils/isApparelEnabled'];
    },
    isBackpack() {
      return this.$store.state.utils.pdm !== null && this.$store.state.utils.pdm.sku === 'backpack';
    },
    customsAssets() {
      return this.$store.state.endPoints.customizer.customsAssets;
    },
    configuration() {
      return this.$store.state.utils.configuration;
    },
    regionIsApac() {
      return this.$store.getters['utils/regionIsApac'];
    },
    isSplashModalOpen() {
      return this.$store.state.utils.isSplashModalOpen;
    },
  },
  watch: {
    isLoading(newValue) {
      if (!newValue) {
        this.showComponentsHelpers();
      }
    }
  },
  methods: {
    backgroundClick(event) {
      if (event.target.classList.contains('splash-page')) {
        this.closeClick();
      }
    },
    getTranslation(key) {
      return this.translations.simplifiedSplashPage.desktop[key];
    },
    closeClick() {
      if (!this.regionIsApac) {
        document.getElementsByClassName('v--modal-overlay')[0].style.position = 'fixed';
      }

      this.toggleSplashPageOpenClass('remove');
      if(this.isSplashModalOpen){
        this.$emit("restoreModel3D");
      }
    },
    setStyleForElements() {
      document.getElementsByClassName('v--modal-overlay')[0].style.setProperty('z-index', '1100', 'important');
      this.$eventBus.$emit("change-scene-settings", false);
      this.checkAllPartsOverlaps();
    },
    getSelectors() {
      const { enableCustomizerNewHeader = false } = this.configuration;
      const customizerHeaderKey = !enableCustomizerNewHeader ? 'customizer-header' : 'customizer-new-header';
      const selectors = [];

      if (this.verifyModuleVisibility('all_parts') || this.verifyModuleVisibility('tabs')) {
        selectors.push(customizerHeaderKey);
        if (this.$store.getters['utils/isApparelEnabled'] || this.configuration.enableFlyOutMenu) {
          selectors.push('standard-navigation', 'standard-arrow-navigation', 'swatches-view-header', 'swatches-view-wrapper-tabs');
        } else {
          selectors.push('customizer-legacy-navigation', 'customizer-legacy-navigation-main', 'swatches-view-header', 'swatches-view-wrapper-tabs');
        }
      }

      if (this.verifyModuleVisibility('header')) {
        selectors.push('customizer-new-header__container-other-buttons');
      }

      return selectors;
    },
    /**
     * @function onSkip
     * Close the splash page
     */
    onSkip() {
      const timeElapsed = (Date.now() - this.initialTimestamp) / 1000;
      this.$customizerDataLayer.logAnalyticsEvent({
        type: this.$customizerDataLayer.types.customizerSplashPage,
        eventLabel: `Skip to Get Started - ${ timeElapsed.toFixed(2) } sec`,
        forceEcomDataLayerFormat: true,
      });
      this.closeClick();
    },
    toggleSplashPageOpenClass(method = 'add') {
      const selectors = this.getSelectors();
      for (let selector of selectors) {
        try {
          if(selector === "swatches-view-header" && !this.verifyModuleVisibility('buy_panel')) {
            document.getElementsByClassName(selector)[0].classList[method]('splash-desktop-modal-open-alt-bottom');
          } else {
            document.getElementsByClassName(selector)[0].classList[method]('splash-desktop-modal-open');
          }
        } catch(err) {
          console.error(`not existing class: ${selector}`)
        }
      }
    },
    showComponentsHelpers() {
      if (!this.regionIsApac) {
        document.getElementsByClassName('v--modal-overlay')[0].style.position = 'initial';
      }

      this.toggleSplashPageOpenClass();
      this.$nextTick(() => {
        this.checkAllPartsOverlaps()
      });
    },
    setOpacity(opacity = 1) {
      this.opacity = opacity;
    },
    getRotateTranslation() {
      if (this.isApparel) return this.getTranslation('rotateApparel');
      else if (this.isBackpack) return this.getTranslation('rotateBackpack');
      else return this.getTranslation('rotateShoe');
    },
    verifyModuleVisibility(module) {
      const general_splash_page = this.configuration.splash_page.models_properties;
      const pdm_model = this.$store.state.utils.pdmModel;
      const model_splash_page = general_splash_page[pdm_model] || general_splash_page["default"];
      return model_splash_page[module];
    },
    faqsAction() {
      window.open(this.getTranslation('faqsLink'), '_blank');
      this.$customizerDataLayer.logAnalyticsEvent({
        type: this.$customizerDataLayer.types.customizerSplashPage,
        eventLabel: 'FAQ',
        forceEcomDataLayerFormat: true,
      });
    },
    setModel3DContainerEl(el){
      this.model3DContainerEl = el;
    },
    checkAllPartsOverlaps() {
      const innerHeight = window.innerHeight;
      const partsCustomize = this.$refs.partsCustomize;
      const partsCustomizeRect = partsCustomize.getBoundingClientRect();
      let navTop;
      if (!this.configuration.enableFlyOutMenu && !this.$store.getters['utils/isApparelEnabled']) {
        navTop = document.querySelector('.customizer-legacy-navigation.splash-desktop-modal-open').getBoundingClientRect().top;
      } else {
        navTop = document.querySelector('.standard-arrow-navigation.splash-desktop-modal-open').getBoundingClientRect().top;
      }
        // If navTop is smaller than Parts bottom is overlapped, move 10px above
      if (navTop < partsCustomizeRect.bottom) partsCustomize.style.bottom = `${innerHeight - (navTop - 10)}px`;
    },
    /**
     * Centers the model 3D container element between up and down arrows.
     */
    adjustModel3DContainerPosition() {
      if (!this.regionIsApac) return;
      const { rotateUp, rotateDown } = this.$refs;
      if (!this.model3DContainerEl || !rotateUp || !rotateDown) return;
      // distance from the top of the "rotate up" arrow to the bottom of the "rotate down" arrow
      const distFromUpToBottom = rotateDown.getBoundingClientRect().bottom - rotateUp.getBoundingClientRect().top;
      // the start position plus half the distance
      const yCoordBetweenArrows = rotateUp.getBoundingClientRect().top + distFromUpToBottom/2;
      // the height of the 3D model canvas
      const canvasHeight = this.model3DContainerEl.getBoundingClientRect().height;
      // move the canvas to the y coordinate of the line between the two arrows subtracted from half of the canvas height
      const calculatedTop = (yCoordBetweenArrows - canvasHeight/2) / 2;
      // update the top CSS attribute
      this.model3DContainerEl.style.top = `${calculatedTop}px`;
    },
  },
  created() {
    window.addEventListener('resize', this.setStyleForElements);
  },
  mounted() {
    this.initialTimestamp = Date.now();
  },
  updated() {
    this.adjustModel3DContainerPosition();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setStyleForElements);
  }
}
</script>